import React, { Component } from 'react';
import Modal from '../components/Modal.js';
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl';

import helpers from '../util/helpers';

import '../css/ChemicalsAndHealth.css';

class HealthModal extends Component {
  render() {
    return (
      <Modal onClose={this.props.onClose} className='left-align'>
        <FormattedHTMLMessage id="chemicals_and_health.read_more_content" />
      </Modal>
    );
  }
}

class HealthAndChemicalsPage extends Component {
  constructor() {
    super();
    this.state = {
      modal: false,
      showMore: false,
    }
  }

  onClick() {
    if (this.state.showMore) {
      helpers.eventLog("modal - lesshealth");
    } else {
      helpers.eventLog("modal - morehealth");
    }
    // this.setState({ modal: true });
    // document.getElementsByTagName("body")[0].style.overflow = "hidden";
    this.setState({showMore: !this.state.showMore})

  }

  onClose() {
    // this.setState({ modal: false });
    // document.getElementsByTagName("body")[0].style.overflow = "visible";
  }

  render() {
    const modal = this.state.modal ? (
      <HealthModal onClose={this.onClose.bind(this)} />
    ) : null;

    let readMoreButton
    if (this.state.showMore) {
      readMoreButton = (
        <a className='button secondary scroll-content arrow-up' onClick={this.onClick.bind(this)}>
          <FormattedMessage id="show_less" defaultMessage="Show less" />
        </a>
      )
    } else {
      readMoreButton = (
        <a className='button secondary scroll-content arrow-down' onClick={this.onClick.bind(this)}>
          <FormattedMessage id="chemicals_and_health.read_more_button" defaultMessage="Show more" />
        </a>
      )
    }

    let additionText;
    if (this.state.showMore) {
      additionText = <FormattedHTMLMessage id="chemicals_and_health.read_more_content" />
    }

    return (
      <div className="page healthandchemicals">
        <h1><FormattedMessage id="chemicals_and_health.title" defaultMessage="Chemicals and Health" /></h1>

        <FormattedHTMLMessage id="chemicals_and_health.description" />

        <br/>

        {additionText}

        {readMoreButton}

      </div>
    );
  }
}

export default HealthAndChemicalsPage;



// WEBPACK FOOTER //
// ./src/pages/HealthAndChemicalsPage.js